module.exports = __webpack_public_path__ + "static/015-9402ef1c1b51dba582c0bb9e4b64d5e1.jpg";